export interface AgrUserClaims {
  given_name: string;
  family_name: string;
  name: string;
  email: string;
  [AgrUserClaimsProperty.ApplicationsCustomPolicy]?: string;
  [AgrUserClaimsProperty.ApplicationsUserFlow]?: string;
}

export interface AccessRule {
  RoleKey: AccessRoleTypes;
  ApplicationKey: string;
  IsLicenseActive: boolean;
}

export enum AccessRoleTypes {
  Administrator = 'Administrator',
  Advisor = 'Advisor',
  BusinessPartner = 'BusinessPartner',
  Customer = 'Customer',
  GlobalAdministrator = 'GlobalAdministrator',
  NotAuthorized = 'NotAuthorized',
  SalesAreaKeyUser = 'SalesAreaKeyUser',
  Transporter = 'Transporter',
}

export enum AgrUserClaimsProperty {
  ApplicationsCustomPolicy = 'https://next.agrifirm.com/applications',
  ApplicationsUserFlow = 'extension_Applications',
}
